import { IconAlertsDanger } from '@doltech/icons/IconAlertsDanger';
import { IconAlertsInfo } from '@doltech/icons/IconAlertsInfo';
import { IconArrowsCheckO } from '@doltech/icons/IconArrowsCheckO';
import { IconButtonsCloseO } from '@doltech/icons/IconButtonsCloseO';
import { Col, Row } from 'antd';
import * as React from 'react';

import { Button } from '../../../ButtonV2/ButtonV2';
import { colorsV2 } from '../../../colors-v2';
import { BaseModalContent, BaseModalContentProps } from '../BaseModal/BaseModalContent';

export interface ModalInformationContentProps extends BaseModalContentProps {
  type?: 'default' | 'info' | 'warning' | 'success' | 'error';
}

export const ModalInformationContent = (props: ModalInformationContentProps) => {
  const { children, onOk, okText, type = 'default', icon, ...rest } = props;

  let iconStatus = icon;
  switch (type) {
    case 'info':
      iconStatus = <IconAlertsInfo fontSize={32} color={colorsV2.blue100} />;
      break;
    case 'warning':
      iconStatus = <IconAlertsDanger fontSize={32} color={colorsV2.yellow100} />;
      break;
    case 'success':
      iconStatus = <IconArrowsCheckO fontSize={32} color={colorsV2.green100} />;
      break;
    case 'error':
      iconStatus = <IconButtonsCloseO fontSize={32} color={colorsV2.primary100} />;
      break;
    default:
  }

  return (
    <BaseModalContent
      icon={iconStatus}
      footer={
        <Row justify="end">
          <Col>
            <Button.Primary onClick={onOk}>{okText}</Button.Primary>
          </Col>
        </Row>
      }
      {...rest}
    >
      {children}
    </BaseModalContent>
  );
};
